import OurServiceSection from '../../Components/OurServiceSection'
import UnbeatableSection from '../../Components/UnbeatableSection'
import './styles.scss'

import titleIcon1 from '../../Assets/Images/title-icon-1.png'
import about1 from '../../Assets/Images/about-1.jpg'
import Animate from '../../Components/Animate'
import useInView from '../../Hooks/useInView'

const AboutUs = () => {
  const [testimonialsRef, testimonialsInView] = useInView()

  return (
    <div className="about-us">
      <div className="about-us__top">
        <h1>About Us</h1>
      </div>

      <div className="about-us__content">
        <section>
          <Animate type="fade-left" className="section1-col">
            <span className="title-text">
              <img src={titleIcon1} alt="" />
              Who We Are?
            </span>

            <h4>Over 30 years of experience in Logistics services</h4>

            <p>
              We're one of the leading independent shipping and logistics
              providers. Trusted since 1993 by some of the world's leading
              companies, we provide liner and port agency services, freight
              forwarding by sea, air and road, warehousing &amp; distribution
              services and end-to-end supply chain management.
            </p>
          </Animate>

          <Animate type="fade-right" delay={0.15} className="section1-col">
            <img src={about1} alt="" />
          </Animate>
        </section>

        <section
          ref={testimonialsRef}
          className={`stagger ${testimonialsInView ? 'in-view' : ''}`}
        >
          <div className="testimonial">
            <h4>Mission</h4>

            <p>
              As a client-centered logistics company, our mission is to offer
              high-performance solutions that exceed customer expectations
              through high quality service, cost control, continuous
              advancement of technology and development of our human capital.
            </p>
          </div>

          <div className="testimonial">
            <h4>Vision</h4>

            <p>
              At Stanbit Logistics, we are committed to surpassing customer
              expectations through innovation, creativity and an uncompromising
              dedication to quality, transparency and integrity in every
              solution we deliver.
            </p>
          </div>
        </section>

        <UnbeatableSection />

        <OurServiceSection />
      </div>
    </div>
  )
}

export default AboutUs
